/**
 * swisspostsolutionscms - JSON API
 * This is a JSON API compliant implementation
 *
 * The version of the OpenAPI document: Versioning not supported
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentDescription } from './documentDescription';
import { URLAlias } from './uRLAlias';


/**
 * Entity attributes
 */
export interface MediaDocumentDataAttributes { 
    field_select_gated_form?: MediaDocumentDataAttributes.FieldSelectGatedFormEnum;
    field_description?: string;
    field_publishing_date?: string;
    /**
     * The meta tags for the entity.
     */
    metatag: object;
    field_sticky?: boolean;
    field_title?: string;
    field_document_category?: Array<MediaDocumentDataAttributes.FieldDocumentCategoryEnum>;
    field_location_document?: MediaDocumentDataAttributes.FieldLocationDocumentEnum;
    path: URLAlias;
    field_read_time?: string;
    langcode?: string;
    field_document_description?: DocumentDescription;
    field_exclude_from_kc?: MediaDocumentDataAttributes.FieldExcludeFromKcEnum;
    field_industry_category?: Array<MediaDocumentDataAttributes.FieldIndustryCategoryEnum>;
    field_document_type: MediaDocumentDataAttributes.FieldDocumentTypeEnum;
    name: string;
    field_solution_category?: Array<MediaDocumentDataAttributes.FieldSolutionCategoryEnum>;
    /**
     * The moderation state of this piece of content.
     */
    moderation_state?: string;
    /**
     * The time the media item was last edited.
     */
    changed?: string;
}
export namespace MediaDocumentDataAttributes {
    export type FieldSelectGatedFormEnum = 'short' | 'standard';
    export const FieldSelectGatedFormEnum = {
        Short: 'short' as FieldSelectGatedFormEnum,
        Standard: 'standard' as FieldSelectGatedFormEnum
    };
    export type FieldDocumentCategoryEnum = 'AI_&_Tec' | 'About_SPS' | 'Business_efficiency' | 'Customer_Experience' | 'Employee_Experience' | 'Smart_workplaces';
    export const FieldDocumentCategoryEnum = {
        AiTec: 'AI_&_Tec' as FieldDocumentCategoryEnum,
        AboutSps: 'About_SPS' as FieldDocumentCategoryEnum,
        BusinessEfficiency: 'Business_efficiency' as FieldDocumentCategoryEnum,
        CustomerExperience: 'Customer_Experience' as FieldDocumentCategoryEnum,
        EmployeeExperience: 'Employee_Experience' as FieldDocumentCategoryEnum,
        SmartWorkplaces: 'Smart_workplaces' as FieldDocumentCategoryEnum
    };
    export type FieldLocationDocumentEnum = 'eu' | 'us';
    export const FieldLocationDocumentEnum = {
        Eu: 'eu' as FieldLocationDocumentEnum,
        Us: 'us' as FieldLocationDocumentEnum
    };
    export type FieldExcludeFromKcEnum = 'yes' | 'no';
    export const FieldExcludeFromKcEnum = {
        Yes: 'yes' as FieldExcludeFromKcEnum,
        No: 'no' as FieldExcludeFromKcEnum
    };
    export type FieldIndustryCategoryEnum = 'Banking' | 'Insurance' | 'Healthcare' | 'Legal_law_firms' | 'Others';
    export const FieldIndustryCategoryEnum = {
        Banking: 'Banking' as FieldIndustryCategoryEnum,
        Insurance: 'Insurance' as FieldIndustryCategoryEnum,
        Healthcare: 'Healthcare' as FieldIndustryCategoryEnum,
        LegalLawFirms: 'Legal_law_firms' as FieldIndustryCategoryEnum,
        Others: 'Others' as FieldIndustryCategoryEnum
    };
    export type FieldDocumentTypeEnum = 'Whitepaper' | 'Article' | 'Market_research' | 'Brochure' | 'Case_study' | 'Infographic' | 'Fact_sheet' | 'Podcast' | 'Videos';
    export const FieldDocumentTypeEnum = {
        Whitepaper: 'Whitepaper' as FieldDocumentTypeEnum,
        Article: 'Article' as FieldDocumentTypeEnum,
        MarketResearch: 'Market_research' as FieldDocumentTypeEnum,
        Brochure: 'Brochure' as FieldDocumentTypeEnum,
        CaseStudy: 'Case_study' as FieldDocumentTypeEnum,
        Infographic: 'Infographic' as FieldDocumentTypeEnum,
        FactSheet: 'Fact_sheet' as FieldDocumentTypeEnum,
        Podcast: 'Podcast' as FieldDocumentTypeEnum,
        Videos: 'Videos' as FieldDocumentTypeEnum
    };
    export type FieldSolutionCategoryEnum = 'Document Management Services' | 'Business Process Services' | 'Intelligent Automation' | 'Digital Transformatoin';
    export const FieldSolutionCategoryEnum = {
        DocumentManagementServices: 'Document Management Services' as FieldSolutionCategoryEnum,
        BusinessProcessServices: 'Business Process Services' as FieldSolutionCategoryEnum,
        IntelligentAutomation: 'Intelligent Automation' as FieldSolutionCategoryEnum,
        DigitalTransformatoin: 'Digital Transformatoin' as FieldSolutionCategoryEnum
    };
}


